import {Component, OnInit, Input} from '@angular/core';
import {CustomerModel} from '../../models/customer.model';
import {SiteModel} from '../../models/site.model';
import {ContactModel} from '../../models/contact.model';
import {DetaillineDTOModel} from 'src/app/models/detaillineDTO.model';
import {AlertController, ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {GeneralService} from '../../services/general.service';
import {PersistDocumentService} from '../../services/persist-document.service';
import {ValidateDocumentService} from '../../services/validate-document.service';
import {AdjustDetailLinesDatesService} from '../../services/adjust-detail-lines-dates.service';

@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.page.html',
    styleUrls: ['./invoice.page.scss'],
})
export class InvoicePage implements OnInit {

    @Input() document: DocumentModel;
    documentTemp: DocumentModel;

    constructor(private customer: CustomerModel,
                private site: SiteModel,
                private contactModel: ContactModel,
                private alertController: AlertController,
                private modalController: ModalController,
                private generalServices: GeneralService,
                private persistDocService: PersistDocumentService,
                private validateDoc: ValidateDocumentService,
                private adjustDetailLinesDates: AdjustDetailLinesDatesService) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
    }


    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.contact = new ContactModel();
        this.documentTemp.signatureContact = new ContactModel();
        this.documentTemp.site = new SiteModel();
        this.documentTemp.signature = null;
        this.documentTemp.detailLines = new Array<DetaillineDTOModel>();
    }

    listenSignature(event: string) {
        if (event) {
            this.documentTemp.queuedToOperatorId = null;
        }
    }

    saveInvoice() {
        if (!this.validateDoc.isValid(this.documentTemp)) {
            return;
        } else {
            this.document = JSON.parse(JSON.stringify(this.documentTemp));
            this.persistDocService.persistDocument(this.document);
            this.modalController.dismiss(this.document);
            this.generalServices.createToast('Invoice Saved!');
        }
    }

    async cancelInvoice() {
        if (JSON.stringify((this.document)) !== JSON.stringify(this.documentTemp)) {
            const alert = await this.alertController.create({
                message: 'Do you want to cancel the Invoice?',
                backdropDismiss: false,
                buttons: [
                    {
                        text: 'No',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                        }
                    }, {
                        text: 'Yes',
                        handler: () => {
                            this.modalController.dismiss();
                        }
                    }
                ]
            });
            await alert.present();
        } else {
            this.modalController.dismiss();
        }
    }

}
